module.exports = "query {\n    onBoardingTypes {\n        id\n        poll_value_id\n        type\n        passed\n    }\n}\n"